export function GridBackground() {
  return (
    <div className="absolute inset-0 w-full h-full">
      <div className="absolute inset-0 bg-dot-white/[0.04] [mask-image:radial-gradient(ellipse_80%_60%_at_50%_0%,#000_60%,transparent_100%)]" />
    </div>
  );
}

export default GridBackground;
